import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { MdClose, MdSave } from 'react-icons/md';
import DefaultButton from '../../ReusableComponents/DefaultButton';
import Attention from '../../ReusableComponents/Attention';
import PortalModal from './PortalModal';
import { ErrorNotice } from './Feedback';

export default function PortalFormModal({
  title,
  description,
  icon,
  onClose,
  onSubmit,
  children,
  error,
  busy = false,
  allowed = true,
  submitDisabled = false,
  submitText = 'Salvar alterações',
  submitIcon = <MdSave />,
  loadingText = 'Salvando…',
  requiredNote = true,
  size,
  id,
}) {
  return (
    <PortalModal
      title={title}
      description={description}
      icon={icon}
      busy={busy}
      onClose={onClose}
      size={size}
      id={id}
    >
      <form
        className="portal-admin-form portal-modal-form hidethis"
        onSubmit={(event) => {
          event.preventDefault();
          if (!allowed || busy || submitDisabled || !submitText) return;
          onSubmit(event);
        }}
      >
        <Modal.Body>
          <ErrorNotice error={error} />
          {requiredNote && (
            <p className="portal-required-note">
              Os campos com <Attention /> são obrigatórios.
            </p>
          )}
          <fieldset disabled={!allowed || busy}>{children}</fieldset>
        </Modal.Body>
        <Modal.Footer>
          <DefaultButton
            text={submitText ? 'Cancelar' : 'Fechar'}
            bg="secondary"
            icon={<MdClose />}
            disabled={busy}
            onClick={onClose}
          />
          {submitText && (
            <DefaultButton
              type="submit"
              text={submitText}
              bg="confirm"
              icon={submitIcon}
              loading={busy}
              loadingtext={loadingText}
              disabled={!allowed || submitDisabled}
            />
          )}
        </Modal.Footer>
      </form>
    </PortalModal>
  );
}
